<div class="mdc-dialog" id="mdc-dialog" (click)="close()">
    <div class="mdc-dialog__container">
        <div class="mdc-dialog__surface container campaign-dialog" role="alertdialog" aria-modal="true"
            aria-labelledby="my-dialog-title" aria-describedby="my-dialog-content">
            <div class="row">
                <div class="title_container col-4 col-sm-12" id="my-dialog-title">
                    <h2 class="title" [innerHtml]="title1"></h2>
                    <div class="campaign-mobile-popup-logo">
                        <img src="{{campaignConstants.POP_IMG}}" alt="">
                    </div>
                </div>
                <div class="mdc-dialog__content col-8 col-sm-12" id="my-dialog-content">
                    <div class="campaign-popup-logo">
                        <img src="{{campaignConstants.POP_IMG}}" alt="">
                    </div>
                    <div class="description" [innerHtml]="description">
                    </div>
                    <div class="description_two" [innerHtml]="description2"></div>
                </div>
            </div>
            <i class="mdc-icon-button material-icons close-button" (click)="close()">close</i>
        </div>
    </div>
</div>